import { render, staticRenderFns } from "./StepPriveRv.vue?vue&type=template&id=564487c6&scoped=true&"
import script from "./StepPriveRv.vue?vue&type=script&lang=js&"
export * from "./StepPriveRv.vue?vue&type=script&lang=js&"
import style0 from "./StepPriveRv.vue?vue&type=style&index=0&id=564487c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564487c6",
  null
  
)

export default component.exports